import { isFunction } from "./is-function";

export const arrayOf = <T>(
  length: number,
  iteratee: ((index: number, length: number) => T) | T,
): T[] => {
  if (!isFunction(iteratee)) return Array(length).fill(iteratee);
  return Array.from({ length }, (_, index) => iteratee(index, length));
};
